exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.sendMessageInfo .commom-dialog .el-form[data-v-365b99f6]{padding:.2rem\n}\n.sendMessageInfo .commom-dialog .el-form-item[data-v-365b99f6]{width:80%;margin-left:0\n}", "", {"version":3,"sources":["/home/jenkins/workspace/pipeline-10323-UAT-kmos-web-ci-cd-6005/html/PC/src/components/imageNode/child/sendMessage.vue"],"names":[],"mappings":";AACA,0DAA0D,aAAa;CACtE;AACD,+DAA+D,UAAU,aAAa;CACrF","file":"sendMessage.vue","sourcesContent":["\n.sendMessageInfo .commom-dialog .el-form[data-v-365b99f6]{padding:.2rem\n}\n.sendMessageInfo .commom-dialog .el-form-item[data-v-365b99f6]{width:80%;margin-left:0\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-365b99f6","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/style-rem-loader??ref--1!./src/components/imageNode/child/sendMessage.vue
// module id = 1280
// module chunks = 2